import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import {
  LOGIN_PATH,
  BASE_PATH,
  ALCOHOL_PATH,
  ATTANDANCE_PATH,
  DRIVER_PATH,
  VEHICLE_PATH,
  DEVICE_PATH,
  Driver_ID_PATH,
  VEHICLE_ID_PATH,
  DRIVER_HEALTHCHECK_DETAIL,
  CLIENT_PATH,
  CLIENT_ID_PATH_EDIT,
  CLIENT_ID_PATH_VIEW,
  CLIENT_PATH_ADD,
  VEHICLE_USER_ID_PATH,
} from './pathName';
import NotFound from 'components/NotFound';
import Login from 'components/Login';
import Layout from 'components/layout/Layout';
import Dashboard from 'components/Dashboard';
import Alcohol from 'components/Alcohol';
import Attendance from 'components/Attendance';
import Driver from 'components/Driver';
import Vehicle from 'components/Vehicle';
import Device from 'components/Device';
import DriverView from 'components/Driver/DriverView/DriverView';
import ForgotPassword from 'components/Login/ForgotPassword/forgotPassword';
import ResetPassword from 'components/Login/ForgotPassword/resetPassword';
import NewPassword from 'components/Login/ForgotPassword/newPassword';
import VehicleInspectionDetails from 'components/Vehicle/VehicleInspectionDetails';
import DriverHealthCheckDetails from 'components/Driver/DriverView/DriverViewTable/DriverHealthCheckDetail';
import Client from 'components/Client';
import VehicleProfile from 'components/Vehicle/VehicleProfile';
import EditClient from 'components/Client/Action/EditClient';
import AddClient from 'components/Client/Action/AddClient';
import ViewClient from 'components/Client/Action/ViewClient';

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="" element={<Layout />}>
          <Route path={BASE_PATH} element={<Dashboard />} />
          <Route path={ALCOHOL_PATH} element={<Alcohol />} />
          <Route path={ATTANDANCE_PATH} element={<Attendance />} />
          <Route path={DRIVER_PATH} element={<Driver />} />
          <Route path={Driver_ID_PATH} element={<DriverView />} />
          <Route
            path={DRIVER_HEALTHCHECK_DETAIL}
            element={<DriverHealthCheckDetails />}
          />
          <Route path={VEHICLE_PATH} element={<Vehicle />} />
          <Route
            path={VEHICLE_ID_PATH}
            element={<VehicleInspectionDetails />}
          />
          <Route path={VEHICLE_USER_ID_PATH} element={<VehicleProfile />} />
          <Route path={DEVICE_PATH} element={<Device />} />
          <Route path={CLIENT_PATH} element={<Client />} />
          <Route path={CLIENT_PATH_ADD} element={<AddClient />} />
          <Route path={CLIENT_ID_PATH_EDIT} element={<EditClient />} />
          <Route path={CLIENT_ID_PATH_VIEW} element={<ViewClient />} />
        </Route>
        <Route path={LOGIN_PATH} element={<Login />} />
        <Route path={`forgot-password`} element={<ForgotPassword />} />
        <Route path={`reset-password`} element={<ResetPassword />} />
        <Route path={`new-password`} element={<NewPassword />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
